var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.0472 0.143657C1.32181 0.141323 1.58705 0.243435 1.7892 0.429314L5.00284 3.46228L8.21077 0.432884C8.41266 0.246839 8.67715 0.143555 8.95169 0.143555C9.22624 0.143555 9.49073 0.246839 9.69262 0.432884C9.78951 0.52198 9.86686 0.630216 9.91977 0.750744C9.97268 0.871273 10 1.00147 10 1.1331C10 1.26473 9.97268 1.39493 9.91977 1.51546C9.86686 1.63599 9.78951 1.74422 9.69262 1.83332L5.73984 5.56614C5.53865 5.75302 5.27422 5.85688 4.99963 5.85688C4.72504 5.85688 4.46061 5.75302 4.25942 5.56614L0.308066 1.83332C0.210978 1.74434 0.133456 1.63614 0.0804212 1.5156C0.0273869 1.39505 0 1.2648 0 1.1331C0 1.00141 0.0273869 0.871151 0.0804212 0.750607C0.133456 0.630063 0.210978 0.521865 0.308066 0.432884C0.508715 0.246011 0.773014 0.14259 1.0472 0.143657Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIcon);
export default __webpack_public_path__ + "static/media/dropdownIcon.ed20ad1b3c84d3cd658f7be935771a96.svg";
export { ForwardRef as ReactComponent };